export default "__VITE_ASSET__BsRuDeso__"